// recaptchaHelpers.js

let recaptchaLoaded = false;
let recaptchaPromise = null;

export function loadRecaptchaScript() {
  if (recaptchaPromise) return recaptchaPromise;
  recaptchaPromise = new Promise((resolve, reject) => {
    if (window.grecaptcha) {
      recaptchaLoaded = true;
      return resolve();
    }

    const existing = document.getElementById('recaptcha-script');
    if (existing) {
      let attempts = 0;
      const poll = () => {
        attempts++;
        if (window.grecaptcha) {
          recaptchaLoaded = true;
          resolve();
        } else if (attempts > 50) {
          reject(new Error('reCAPTCHA failed to initialize'));
        } else {
          setTimeout(poll, 100);
        }
      };
      return poll();
    }

    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    if (!siteKey) {
      return reject(new Error('Missing reCAPTCHA site key'));
    }

    const script = document.createElement('script');
    script.id = 'recaptcha-script';
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      let attempts = 0;
      const check = () => {
        attempts++;
        if (window.grecaptcha) {
          recaptchaLoaded = true;
          resolve();
        } else if (attempts > 50) {
          reject(new Error('reCAPTCHA did not load in time'));
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    };
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA script'));
    document.head.appendChild(script);
  });
  return recaptchaPromise;
}

export async function executeRecaptcha(action = 'submit') {
  try {
    await loadRecaptchaScript();
    if (!window.grecaptcha) throw new Error('reCAPTCHA not ready');
    const token = await window.grecaptcha.execute(
      process.env.REACT_APP_RECAPTCHA_SITE_KEY,
      { action }
    );
    return token;
  } catch (err) {
    console.error('reCAPTCHA error:', err.message);
    throw err;
  }
}
